import { Component } from '@angular/core';

@Component({
  selector: 'app-workshops24',
  templateUrl: './workshops24.component.html',
  styleUrl: './workshops24.component.css'
})

export class Workshops24Component {

}
